import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { TRANSCRIPTION_DOCUMENT_API_URL } from '../../../../constants/ApiUrlConstants';
import { getApiRequest } from '../../../../features/axiosClient';
import { editorDocumentFailure, editorDocumentSuccess } from '../actions';

const editorDocumentAPI = (action) => getApiRequest(`${TRANSCRIPTION_DOCUMENT_API_URL}?AudioFileId=${action}`);

function* handleEditorDocument(action) {
  try {
    const response = yield call(editorDocumentAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(editorDocumentSuccess(response));
  } catch (error) {
    yield put(editorDocumentFailure(error));
  }
}

export function* watchEditorDocument() {
  yield takeLatest(types.EDITOR_DOCUMENTS_REQUEST, handleEditorDocument);
}
